<script setup lang="ts">
import Store from '~/components/Common/Store.vue'
import { StoreName } from '~/interfaces/network'
import MobileWithPerspective from '~/components/UI/images/mobileWithPerspective.vue'
import { getAppStoreChargemapUrl, getPlayStoreChargemapUrl } from '~/utils/url'

const { isApple } = useDevice()

const { locale } = useI18n()

const storeName = computed(() =>
    isApple ? StoreName.AppStore : StoreName.GooglePlay
)

const imageUrl = computed(() => {
    switch (storeName.value) {
        case StoreName.AppStore:
            return getAppStoreChargemapUrl(locale.value)
        case StoreName.GooglePlay:
            return getPlayStoreChargemapUrl(locale.value)
        default:
            return ''
    }
})
</script>

<template>
    <div
        class="px-4 py-6 bg-zinc-100 rounded-lg flex-col justify-center items-center gap-4 inline-flex mx-2"
    >
        <a
            target="_blank"
            :href="imageUrl"
            :title="$t('home.download.' + storeName)"
        >
            <MobileWithPerspective class="w-48 h-48" />
        </a>
        <div class="max-w-80 text-center">
            <span
                class="text-sky-500 text-base font-bold font-inter leading-tight"
            >
                <i18n-t keypath="cta.download_app.title" scope="global">
                    <template #onApp>
                        <span class="text-zinc-800 font-medium">
                            {{ $t('cta.download_app.app_name') }}
                        </span>
                    </template>
                </i18n-t>
            </span>
        </div>
        <div class="flex flex-col justify-center items-center gap-1">
            <Store class="max-w-32" :locale :store-name />
            <span
                class="text-center text-zinc-800 text-base font-medium font-inter leading-tight"
            >
                <i18n-t keypath="cta.download_app.ratings" scope="global">
                    <template #ratings>
                        <span class="text-sky-500 font-bold">
                            {{ $t('community.notes2') }}
                        </span>
                    </template>
                </i18n-t>
            </span>
        </div>
    </div>
</template>
